module.exports = __webpack_public_path__ + "static/media/sambayWelcome.142ba4bc.svg";